import { error } from "console";
import { AuditQuestion } from "../models/AuditQuestion";
import { Audit } from "../models/Audit";
import { AuditDetail } from "../models/AuditDetail";
import { Section } from "../models/Section";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import { QuestionarySubsection } from "../models/QuestionarySubsection";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const insertSubsection = async (subsection: QuestionarySubsection) => {
  const response = await fetch(`${API_BASE_URL}/QuestionarySubsection/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(subsection),
  });

  return response;
};

const updateSubsection = async (subsection: QuestionarySubsection) => {
  const response = await fetch(`${API_BASE_URL}/QuestionarySubsection/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(subsection),
  });

  return response;
};

const deleteSubsection = async (subsection: QuestionarySubsection) => {
  const response = await fetch(`${API_BASE_URL}/QuestionarySubsection/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(subsection),
  });

  return response;
};

export const updatePositions = async (
  updates: { subsectionId: number; newPosition: number }[]
) => {
  const response = await fetch(
    `${API_BASE_URL}/QuestionarySubsection/UpdatePositions`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updates),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to update positions");
  }

  return response;
};

const moveSubsection = async (subsectionId: number, newSectionId: number) => {
  const response = await fetch(
    `${API_BASE_URL}/QuestionarySubsection/MoveSubsection`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ subsectionId, newSectionId }),
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Error al mover la subsección: ${errorText || response.statusText}`
    );
  }

  return response;
};

const QuestionarySubsectionService = {
  insertSubsection,
  updateSubsection,
  deleteSubsection,
  updatePositions,
  moveSubsection,
};

export default QuestionarySubsectionService;
